// Textos do Plano de saúde (27/10/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dp.plano.dadoMinimo': 'Dado mínimo de saúde',
    'dp.plano.titulo': 'Plano de saúde',
    'dp.plano.mesFatura': 'Mês da fatura',
    'dp.plano.vazio': 'Nenhuma fatura carregada ainda. Importe os relatórios de mensalidade e coparticipação da operadora.',
    'dp.plano.explica': 'Uma linha por titular, com a família inteira e os contratos da operadora. Do dependente não há CPF nem procedimento: a coparticipação fica somada no titular.',
    'dp.plano.kpi.titulares': 'Titulares',
    'dp.plano.kpi.beneficiarios': 'Beneficiários',
    'dp.plano.kpi.semFolha': 'Sem matrícula',
    'dp.plano.mensalidade': 'Mensalidade',
    'dp.plano.coparticipacao': 'Coparticipação',
    'dp.plano.col.titular': 'Titular',
    'dp.plano.col.casamento': 'Matrícula',
    'dp.plano.col.beneficiarios': 'Beneficiários',
    'dp.plano.col.beneficiario': 'Beneficiário',
    'dp.plano.col.parentesco': 'Parentesco',
    'dp.plano.col.contrato': 'Contrato',
    'dp.plano.col.cobrado': 'Cobrado',
    'dp.plano.contratoPlano': '{{contrato}}, plano {{plano}}',
    'dp.plano.familia': 'Família',
    'dp.plano.semFolha': 'O titular não casou com a folha pelo CPF. Aponte a filial e a matrícula.',
    'dp.plano.semFolhaCurto': 'Sem matrícula',
    'dp.plano.casamento.cpf': 'Matrícula {{m}}, achada pelo CPF.',
    'dp.plano.casamento.matricula': 'Matrícula {{m}}, achada pela matrícula que a operadora traz.',
    'dp.plano.casamento.confirmado': 'Matrícula {{m}}, confirmada pelo DP.',
    'dp.plano.casamentoCurto.cpf': 'Pelo CPF',
    'dp.plano.casamentoCurto.matricula': 'Pela operadora',
    'dp.plano.casamentoCurto.confirmado': 'Confirmada',
    'dp.plano.apontarTitulo': 'Apontar a matrícula do titular',
    'dp.plano.matricula': 'Matrícula',
    'dp.plano.apontar': 'Usar esta matrícula',
    'dp.plano.confirmar': 'Confirmar a matrícula',
    'dp.plano.importarTitulo': 'Importar a fatura da Hapvida',
    'dp.plano.importarExplica': 'Os dois relatórios da mesma fatura, baixados do portal da operadora: a mensalidade e, quando houver, a coparticipação. O procedimento médico é lido e descartado; carregar o mesmo mês de novo atualiza os valores.',
    'dp.plano.arquivoMensalidade': 'Relatório de mensalidade',
    'dp.plano.arquivoCoparticipacao': 'Relatório de coparticipação',
    'dp.plano.carga.valorFatura': 'Valor da fatura',
    'dp.plano.carga.semTitular': 'Procedimentos sem titular',
  },
  en: {
    'dp.plano.dadoMinimo': 'Minimal health data',
    'dp.plano.titulo': 'Health plan',
    'dp.plano.mesFatura': 'Invoice month',
    'dp.plano.vazio': 'No invoice loaded yet. Import the provider monthly fee and copayment reports.',
    'dp.plano.explica': 'One row per holder, with the whole family and the provider contracts. There is no ID number or procedure for dependents: the copayment is summed on the holder.',
    'dp.plano.kpi.titulares': 'Holders',
    'dp.plano.kpi.beneficiarios': 'Beneficiaries',
    'dp.plano.kpi.semFolha': 'No employee ID',
    'dp.plano.mensalidade': 'Monthly fee',
    'dp.plano.coparticipacao': 'Copayment',
    'dp.plano.col.titular': 'Holder',
    'dp.plano.col.casamento': 'Employee ID',
    'dp.plano.col.beneficiarios': 'Beneficiaries',
    'dp.plano.col.beneficiario': 'Beneficiary',
    'dp.plano.col.parentesco': 'Relationship',
    'dp.plano.col.contrato': 'Contract',
    'dp.plano.col.cobrado': 'Charged',
    'dp.plano.contratoPlano': '{{contrato}}, plan {{plano}}',
    'dp.plano.familia': 'Family',
    'dp.plano.semFolha': 'The holder did not match the payroll by ID number. Point the branch and employee ID.',
    'dp.plano.semFolhaCurto': 'No employee ID',
    'dp.plano.casamento.cpf': 'Employee ID {{m}}, found by ID number.',
    'dp.plano.casamento.matricula': 'Employee ID {{m}}, found by the provider employee ID.',
    'dp.plano.casamento.confirmado': 'Employee ID {{m}}, confirmed by HR.',
    'dp.plano.casamentoCurto.cpf': 'By ID number',
    'dp.plano.casamentoCurto.matricula': 'By provider',
    'dp.plano.casamentoCurto.confirmado': 'Confirmed',
    'dp.plano.apontarTitulo': 'Point the holder employee ID',
    'dp.plano.matricula': 'Employee ID',
    'dp.plano.apontar': 'Use this employee ID',
    'dp.plano.confirmar': 'Confirm the employee ID',
    'dp.plano.importarTitulo': 'Import the Hapvida invoice',
    'dp.plano.importarExplica': 'Both reports of the same invoice, downloaded from the provider portal: the monthly fee and, when there is one, the copayment. The medical procedure is read and discarded; loading the same month again updates the amounts.',
    'dp.plano.arquivoMensalidade': 'Monthly fee report',
    'dp.plano.arquivoCoparticipacao': 'Copayment report',
    'dp.plano.carga.valorFatura': 'Invoice amount',
    'dp.plano.carga.semTitular': 'Procedures without a holder',
  },
  es: {
    'dp.plano.dadoMinimo': 'Dato mínimo de salud',
    'dp.plano.titulo': 'Plan de salud',
    'dp.plano.mesFatura': 'Mes de la factura',
    'dp.plano.vazio': 'Aún no hay factura cargada. Importe los informes de mensualidad y copago de la operadora.',
    'dp.plano.explica': 'Una fila por titular, con toda la familia y los contratos de la operadora. Del dependiente no hay documento ni procedimiento: el copago queda sumado en el titular.',
    'dp.plano.kpi.titulares': 'Titulares',
    'dp.plano.kpi.beneficiarios': 'Beneficiarios',
    'dp.plano.kpi.semFolha': 'Sin matrícula',
    'dp.plano.mensalidade': 'Mensualidad',
    'dp.plano.coparticipacao': 'Copago',
    'dp.plano.col.titular': 'Titular',
    'dp.plano.col.casamento': 'Matrícula',
    'dp.plano.col.beneficiarios': 'Beneficiarios',
    'dp.plano.col.beneficiario': 'Beneficiario',
    'dp.plano.col.parentesco': 'Parentesco',
    'dp.plano.col.contrato': 'Contrato',
    'dp.plano.col.cobrado': 'Cobrado',
    'dp.plano.contratoPlano': '{{contrato}}, plan {{plano}}',
    'dp.plano.familia': 'Familia',
    'dp.plano.semFolha': 'El titular no coincidió con la nómina por el documento. Indique la filial y la matrícula.',
    'dp.plano.semFolhaCurto': 'Sin matrícula',
    'dp.plano.casamento.cpf': 'Matrícula {{m}}, encontrada por el documento.',
    'dp.plano.casamento.matricula': 'Matrícula {{m}}, encontrada por la matrícula de la operadora.',
    'dp.plano.casamento.confirmado': 'Matrícula {{m}}, confirmada por el DP.',
    'dp.plano.casamentoCurto.cpf': 'Por el documento',
    'dp.plano.casamentoCurto.matricula': 'Por la operadora',
    'dp.plano.casamentoCurto.confirmado': 'Confirmada',
    'dp.plano.apontarTitulo': 'Indicar la matrícula del titular',
    'dp.plano.matricula': 'Matrícula',
    'dp.plano.apontar': 'Usar esta matrícula',
    'dp.plano.confirmar': 'Confirmar la matrícula',
    'dp.plano.importarTitulo': 'Importar la factura de Hapvida',
    'dp.plano.importarExplica': 'Los dos informes de la misma factura, descargados del portal de la operadora: la mensualidad y, cuando haya, el copago. El procedimiento médico se lee y se descarta; cargar el mismo mes de nuevo actualiza los valores.',
    'dp.plano.arquivoMensalidade': 'Informe de mensualidad',
    'dp.plano.arquivoCoparticipacao': 'Informe de copago',
    'dp.plano.carga.valorFatura': 'Valor de la factura',
    'dp.plano.carga.semTitular': 'Procedimientos sin titular',
  },
}
